import type { ReactNode } from 'react';
import './admin-shell.css';

interface Props {
  subnavTag: string;
  publicHref: string;
  onExport(): void;
  loadError?: string | null;
  children: ReactNode;
  savebar: ReactNode;
}

export function AdminShell({ subnavTag, publicHref, onExport, loadError, children, savebar }: Props) {
  return (
    <div className="adm-page">
      <div className="adm-subnav">
        <span className="adm-subnav__tag">{subnavTag}</span>
        <div className="adm-subnav__actions">
          <a className="adm-subnav__link" href={publicHref} target="_blank" rel="noreferrer">
            Open public tool
          </a>
          <button className="adm-subnav__cta" type="button" onClick={onExport}>
            Export JSON
          </button>
        </div>
      </div>
      <div className="adm-layout">
        {loadError && <div className="adm-banner-error">{loadError}</div>}
        {children}
      </div>
      {savebar}
    </div>
  );
}
